// components\missions\user-referrals-in-missions.jsx

/* eslint-disable react-hooks/exhaustive-deps */
import dynamic from 'next/dynamic';

import Image from "next/image";
import React, { useEffect, useState, Fragment } from "react";
import { toast } from "react-toastify";
const LogoLoading = dynamic(() => import('@/components/ui/LogoLoading'));
import { Icon } from "@iconify/react";
import clipboardCopy from "clipboard-copy";
import { fetchUserReferralsByUID, getSignupReferralRewardsByUID, getUserReferralsLeaderboardRecords, getUserReferralsLeaderboardStats } from "@/utils/firebaseFunctions";
import Modal from "@/components/ui/Modal";
import { formatRelativeTime } from "@/utils/generalutils";

import ReferralListInMissions from "./user-referrals-in-missions/referral-list-in-missions";
import InviteFriendsBoxInMissions from "./user-referrals-in-missions/invite-friends-box-in-missions";
import ReferralInfoBoxInMissions from "./user-referrals-in-missions/referral-info-box-in-missions";
import UserReferralsLeaderboard from "../partials/app/missions/user-referrals/user-referrals-leaderboard";

import { fetchUserReferralsLeaderboard } from "@/utils/helpers/helperFunctions";

export default function UserReferralsInMissions({ user, address }) {
  const [userLoading, setUserLoading] = useState(true);

  const [userReferrals, setUserReferrals] = useState([]);
  const [userReferralsLoading, setUserReferralsLoading] = useState(true);

  const [userReferralsLeaderboardRecord, setUserReferralsLeaderboardRecord] = useState([]);
  const [userReferralsLeaderboardRecordLoading, setUserReferralsLeaderboardRecordLoading] = useState(true);

  const [userReferralsStats, setUserReferralsStats] = useState([]);
  const [userReferralsStatsLoading, setUserReferralsStatsLoading] = useState(true);

  const [signupReferralRewards, setSignupReferralRewards] = useState([]);
  const [signupReferralRewardsLoading, setSignupReferralRewardsLoading] = useState(true);

  const [signupBonusDialogOpen, setSignupBonusDialogOpen] = useState(false);
  const [activityBonusDialogOpen, setActivityBonusDialogOpen] = useState(false);

  const [leaderboard, setLeaderboard] = useState();
  const [leaderboardLoading, setLeaderboardLoading] = useState(true);
  const [leaderboardLastSignupCount, setLeaderboardLastSignupCount] = useState([]);
  const [leaderboardLastSignupRank, setLeaderboardLastSignupRank] = useState([]);
  const [leaderboardLastActiveCount, setLeaderboardLastActiveCount] = useState([]);
  const [leaderboardLastActiveRank, setLeaderboardLastActiveRank] = useState([]);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    hasNext: false,
    hasPrev: false,
    pageSize: 10
  });

  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (user && address && userLoading === true) {
      setUserLoading(false);

      fetchUserReferrals();
      fetchSignupReferralRewards();
      fetchUserReferralsLeaderboardRecords(user?.user_id, 0);
      fetchUserReferralsStats(user?.user_id);
    }

    if (!address && userLoading) {
      setUserLoading(false);
      setUserReferralsLoading(false);
      setSignupReferralRewardsLoading(false);
      setUserReferralsLeaderboardRecordLoading(false);
      setUserReferralsStatsLoading(false);
    }

    fetchLeaderboard();
  }, [user, userLoading, address]);

  const fetchUserReferralsLeaderboardRecords = async (uid, tabIndex) => {
    try {
      setUserReferralsLeaderboardRecordLoading(true);
      const response = await getUserReferralsLeaderboardRecords(uid, tabIndex);
      setUserReferralsLeaderboardRecord(response);
      setUserReferralsLeaderboardRecordLoading(false);
    } catch (error) {
      console.error("Failed to fetch user referrals leaderboard records:", error);
      setUserReferralsLeaderboardRecordLoading(false);
    }
  };

  const fetchUserReferrals = async () => {
    try {
      setUserReferralsLoading(true);
      let response = await fetchUserReferralsByUID(user?.user_id);
      // Filter out null values
      response = response.filter((user) => user !== null);

      if (response && response.length > 0) {
        const sortedUsers = response.sort((a, b) => {
          if (a.timestamp_dt && b.timestamp_dt) {
            return b.timestamp_dt - a.timestamp_dt;
          }
          return 0;
        });

        setUserReferrals(sortedUsers);
        setUserReferralsLoading(false);
      } else {
        setUserReferrals(response);
        setUserReferralsLoading(false);
      }
    } catch (error) {
      console.error("Failed to fetch or sort user referrals:", error);
      setUserReferralsLoading(false);
    }
  };

  const fetchSignupReferralRewards = async () => {
    try {
      const response = await getSignupReferralRewardsByUID(user?.user_id);
      setSignupReferralRewards(response);
      setSignupReferralRewardsLoading(false);
    } catch (error) {
      console.error(error);
      setSignupReferralRewardsLoading(false);
    }
  };

  const fetchUserReferralsStats = async (uid) => {
    try {
      setUserReferralsStatsLoading(true);
      const response = await getUserReferralsLeaderboardStats(uid);
      // console.log(response);
      setUserReferralsStats(response);
      setUserReferralsStatsLoading(false);
    } catch (error) {
      console.error("Failed to fetch user referrals stats:", error);
      setUserReferralsStatsLoading(false);
    }
  };

  const fetchLeaderboard = async () => {
    try {
      setLeaderboardLoading(true);
      await fetchUserReferralsLeaderboard(
        1, // page
        tabIndex,
        setLeaderboardLoading,
        setLeaderboard,
        setPagination
      );
      setLeaderboardLoading(false);
    } catch (error) {
      console.log("Error fetching leaderboard:", error);

      toast.error("There was an error fetching the leaderboard, trying again...");

      try {
        setLeaderboardLoading(true);
        await fetchUserReferralsLeaderboard(
          1, // page
          tabIndex,
          setLeaderboardLoading,
          setLeaderboard,
          setPagination
        );
        setLeaderboardLoading(false);
      } catch (error) {
        console.log("Error fetching leaderboard:", error);

        toast.error("There was an error fetching the leaderboard, please try again later.");
      }
    }
  };

  const handleCopyUserReferralLink = () => {
    const referralLink = `https://www.metaxseed.io/?referrer=${user?.referral_alias || user?.uid || "Not Connected"}`;
    // Use the clipboard-copy library to copy the link
    clipboardCopy(referralLink);
    toast.success("Referral link copied!");
  };

  const shortenReferralLink = (fullLink, screenWidth) => {
    const maxCharacters = screenWidth > 1536 ? 32 : screenWidth < 1024 && screenWidth > 640 ? 24 : 24; // Adjust the character limit based on your design
    return fullLink.length > maxCharacters ? `${fullLink.substring(0, maxCharacters)}...` : fullLink;
  };

  const handleCopyToClipboard = (text) => {
    clipboardCopy(text);
    toast.success("Copied to clipboard!");
  };

  const leaderboardHandleNext = async (nextPage) => {
    try {
      setLeaderboardLoading(true);
      await fetchUserReferralsLeaderboard(
        nextPage,
        tabIndex,
        setLeaderboardLoading,
        setLeaderboard,
        setPagination
      );
    } catch (error) {
      console.error("Error fetching next page:", error);
      toast.error("Failed to fetch next page");
    }
  };

  const leaderboardHandlePrev = async (prevPage) => {
    try {
      setLeaderboardLoading(true);
      await fetchUserReferralsLeaderboard(
        prevPage,
        tabIndex,
        setLeaderboardLoading,
        setLeaderboard,
        setPagination
      );
    } catch (error) {
      console.error("Error fetching previous page:", error);
      toast.error("Failed to fetch previous page");
    }
  };

  const userReferralsLeaderboard = () => {
    return (
      <UserReferralsLeaderboard
        user={user}
        leaderboard={leaderboard}
        leaderboardLoading={leaderboardLoading}
        userReferralsLeaderboardRecordLoading={userReferralsLeaderboardRecordLoading}
        tabIndex={tabIndex}
        setTabIndex={setTabIndex}
        pagination={pagination}
        setPagination={setPagination}
        leaderboardTabChange={async (newTabIndex) => {
          setTabIndex(newTabIndex);
          try {
            await fetchUserReferralsLeaderboard(
              1, // Reset to page 1 when changing tabs
              newTabIndex,
              setLeaderboardLoading,
              setLeaderboard,
              setPagination
            );

            await fetchUserReferralsLeaderboardRecords(user?.user_id, newTabIndex);
          } catch (error) {
            console.error("Error fetching leaderboard:", error);
            toast.error("Failed to fetch leaderboard");
          }
        }}
        leaderboardHandleNext={leaderboardHandleNext}
        leaderboardHandlePrev={leaderboardHandlePrev}
        userReferrals={userReferralsLeaderboardRecord}
      />
    );
  };

  return (
    <Fragment>
      <Fragment>
        <div className="flex justify-start items-center text-metaxseed-gray mb-8 pl-3">
          <Icon icon="mdi:information" className="w-4 h-4 mr-2" />

          <span>The information on this page is updated periodically.</span>
        </div>
        {(userLoading && !user) || userReferralsLoading || signupReferralRewardsLoading ? (
          <div className="flex items-center justify-center py-16">
            <LogoLoading />
          </div>
        ) : (
          <Fragment>
            {user && !userLoading ? (
              <Fragment>
                {/* 1536px */}
                <div className="2xl:flex hidden flex-row justify-stretch items-start w-full">
                  <div className="flex flex-1 flex-grow flex-col mr-4">{userReferralsLoading ? <LogoLoading /> : <ReferralListInMissions userReferrals={userReferrals} handleCopyToClipboard={handleCopyToClipboard} formatRelativeTime={formatRelativeTime} />}</div>

                  <div className="flex flex-col justify-center items-stretch mt-7">
                    <div className="flex flex-col flex-1 justify-stretch items-stretch rounded-xl flex-grow mb-4">{userReferralsLoading || signupReferralRewardsLoading ? <LogoLoading /> : <InviteFriendsBoxInMissions signupReferralRewards={signupReferralRewards} signupReferralRewardsLoading={signupReferralRewardsLoading} userReferrals={userReferrals} userReferralsLoading={userReferralsLoading} />}</div>

                    <div className="flex flex-1 flex-col bg-metaxseed-blue rounded-xl py-4 px-8 flex-grow">{userReferralsLoading || signupReferralRewardsLoading ? <LogoLoading /> : <ReferralInfoBoxInMissions user={user} shortenReferralLink={shortenReferralLink} handleCopyUserReferralLink={handleCopyUserReferralLink} userReferrals={userReferralsStats} userReferralsLoading={userReferralsStatsLoading} signupReferralRewards={signupReferralRewards} signupReferralRewardsLoading={signupReferralRewardsLoading} setSignupBonusDialogOpen={setSignupBonusDialogOpen} setActivityBonusDialogOpen={setActivityBonusDialogOpen} />}</div>

                    <div className="flex flex-col w-full justify-stretch items-stretch p-4 rounded-lg bg-metaxseed-content-gray mt-4">{userReferralsLeaderboard()}</div>
                  </div>
                </div>
                {/* 1536px */}

                {/* 1280px */}
                <div className="lg:hidden xl:flex 2xl:hidden hidden flex-col justify-stretch items-stretch w-full">
                  <div className="flex flex-row justify-stretch items-center mb-7 w-full">
                    <div className="flex flex-col flex-1 justify-start items-stretch flex-grow mr-4">
                      <div className="flex flex-col flex-1 justify-stretch items-stretch rounded-xl flex-grow h-full mb-4">{userReferralsLoading || signupReferralRewardsLoading ? <LogoLoading /> : <InviteFriendsBoxInMissions signupReferralRewards={signupReferralRewards} signupReferralRewardsLoading={signupReferralRewardsLoading} userReferrals={userReferrals} userReferralsLoading={userReferralsLoading} />}</div>

                      <div className="flex flex-1 flex-col bg-metaxseed-blue rounded-xl py-4 px-8 flex-grow h-full">{userReferralsStatsLoading || signupReferralRewardsLoading ? <LogoLoading /> : <ReferralInfoBoxInMissions user={user} shortenReferralLink={shortenReferralLink} handleCopyUserReferralLink={handleCopyUserReferralLink} userReferrals={userReferralsStats} userReferralsLoading={userReferralsStatsLoading} signupReferralRewards={signupReferralRewards} signupReferralRewardsLoading={signupReferralRewardsLoading} setSignupBonusDialogOpen={setSignupBonusDialogOpen} setActivityBonusDialogOpen={setActivityBonusDialogOpen} />}</div>
                    </div>
                    <div className="flex flex-col flex-1 justify-stretch items-stretch flex-grow mr-4">
                      <div className="flex flex-col w-full justify-stretch items-stretch p-4 rounded-lg bg-metaxseed-content-gray">{userReferralsLeaderboard()}</div>
                    </div>
                  </div>

                  <div className="flex flex-1 flex-grow flex-col">{userReferralsLoading ? <LogoLoading /> : <ReferralListInMissions userReferrals={userReferrals} handleCopyToClipboard={handleCopyToClipboard} formatRelativeTime={formatRelativeTime} />}</div>
                </div>
                {/* 1280px */}

                {/* 1024px */}
                <div className="flex xl:hidden 2xl:hidden flex-col justify-stretch items-stretch w-full">
                  <div className="flex flex-col justify-stretch items-center mb-7 w-full">
                    <div className="flex flex-col flex-1 justify-stretch items-stretch rounded-xl flex-grow h-full w-full mb-4">{userReferralsLoading || signupReferralRewardsLoading ? <LogoLoading /> : <InviteFriendsBoxInMissions signupReferralRewards={signupReferralRewards} signupReferralRewardsLoading={signupReferralRewardsLoading} userReferrals={userReferrals} userReferralsLoading={userReferralsLoading} />}</div>

                    <div className="flex flex-1 flex-col bg-metaxseed-blue rounded-xl py-4 px-8 flex-grow h-full w-full">{userReferralsStatsLoading || signupReferralRewardsLoading ? <LogoLoading /> : <ReferralInfoBoxInMissions user={user} shortenReferralLink={shortenReferralLink} handleCopyUserReferralLink={handleCopyUserReferralLink} userReferrals={userReferralsStats} userReferralsLoading={userReferralsStatsLoading} signupReferralRewards={signupReferralRewards} signupReferralRewardsLoading={signupReferralRewardsLoading} setSignupBonusDialogOpen={setSignupBonusDialogOpen} setActivityBonusDialogOpen={setActivityBonusDialogOpen} />}</div>
                  </div>

                  <div className="flex flex-1 flex-grow flex-col">{userReferralsLoading ? <LogoLoading /> : <ReferralListInMissions userReferrals={userReferrals} handleCopyToClipboard={handleCopyToClipboard} formatRelativeTime={formatRelativeTime} />}</div>

                  <div className="flex flex-col w-full justify-stretch items-stretch p-4 rounded-lg bg-metaxseed-content-gray mt-4">{userReferralsLeaderboard()}</div>
                </div>
                {/* 1024px */}
              </Fragment>
            ) : (
              <div className="flex items-center justify-center bg-metaxseed-content-gray rounded-xl px-4 py-4 mb-4 mt-8">
                <span className="text-metaxseed-light-gray">Connect your wallet to view your user referrals</span>
              </div>
            )}
          </Fragment>
        )}

        {/* Signup Referral Bonus Dialog */}

        {signupBonusDialogOpen && (
          <Modal
            activeModal={signupBonusDialogOpen}
            centered
            onClose={(e) => {
              if (e) {
                setSignupBonusDialogOpen(false);
              }
            }}
            title="Signup Referral Bonus"
            className="max-w-2xl bg-metaxseed-dark-gray"
          >
            <div className="bg-metaxseed-dark-gray">
              <Fragment>
                <div className="flex flex-col">
                  {signupReferralRewards?.length > 0 && (
                    <Fragment>
                      <div className="flex items-center justify-between bg-metaxseed-content-gray rounded-xl px-2 xl:px-4 py-2 mb-2 gothamBook">
                        <span className="flex items-center flex-1 text-sm xl:text-base text-white">Referred UID</span>
                        <span className="flex items-center flex-1 text-sm xl:text-base text-white">When Claimed</span>
                        <span className="flex items-center flex-1 text-sm xl:text-base text-white">MXS Gold</span>
                      </div>

                      <div className="flex flex-col justify-stretch items-stretch max-h-60 overflow-y-scroll overflow-x-hidden">
                        {signupReferralRewards?.map((referral, i) => (
                          <div key={i} className="flex items-center justify-between bg-metaxseed-content-gray rounded-xl px-2 xl:px-4 py-2 mb-2 gothamBook">
                            <div className="flex flex-row justify-start items-center flex-1">
                              <span className="flex items-center text-sm xl:text-base mr-2">{referral.referred_uid.substring(0, 3) + "..." + referral.referred_uid.substring(referral.referred_uid.length - 3)} </span>

                              <button onClick={() => handleCopyToClipboard(referral.referred_uid)} className="cursor-pointer text-zinc-400 dark:text-zinc-600 hover:text-zinc-600 dark:hover:text-zinc-400">
                                <Icon icon="solar:copy-linear" className="text-metaxseed-gray" />
                              </button>
                            </div>
                            <span className="flex items-center flex-1 text-sm xl:text-base">{formatRelativeTime(referral.firebase_timestamp.seconds)}</span>
                            <span className="flex flex-row justify-start items-center flex-1 text-sm xl:text-base">
                              {referral.mxs_gold_claimed}
                              <Image src="https://res.cloudinary.com/dot2onqdb/image/upload/v1729068489/gold_lr_h4yg2m.png" className="w-6 h-6 ml-2" alt="MXS GOLD" width={200} height={200} />
                            </span>
                          </div>
                        ))}
                      </div>

                      <div className="flex items-center justify-between bg-metaxseed-content-gray rounded-xl px-2 xl:px-4 py-2 gothamBook">
                        <span className="flex items-center flex-1 text-sm xl:text-base text-white"></span>
                        <span className="flex items-center flex-1 text-sm xl:text-base text-white"></span>
                        <span className="flex flex-row justify-start items-center flex-1 text-sm xl:text-base text-white">
                          Total: {signupReferralRewards?.map((referral) => referral.mxs_gold_claimed).reduce((a, b) => a + b, 0)}
                          <Image src="https://res.cloudinary.com/dot2onqdb/image/upload/v1729068489/gold_lr_h4yg2m.png" className="w-6 h-6 ml-2" alt="MXS GOLD" width={200} height={200} />
                        </span>
                      </div>
                    </Fragment>
                  )}
                </div>
              </Fragment>
            </div>
          </Modal>
        )}

        {activityBonusDialogOpen && (
          <Modal
            activeModal={activityBonusDialogOpen}
            centered
            onClose={(e) => {
              if (e) {
                setActivityBonusDialogOpen(false);
              }
            }}
            title="Activity Referral Bonus"
            className="max-w-xl bg-metaxseed-dark-gray"
          >
            <div className="bg-metaxseed-dark-gray">
              <Fragment>
                <div className="flex flex-col">
                  {userReferrals?.referred_users?.length > 0 && (
                    <Fragment>
                      <div className="flex items-center justify-between bg-metaxseed-content-gray rounded-xl px-2 xl:px-4 py-2 mb-2 gothamBook">
                        <span className="flex items-center flex-1 text-sm xl:text-base text-white">Referred UID</span>
                        <span className="flex items-center flex-1 text-sm xl:text-base text-white">User's MXS Gold</span>
                        <span className="flex items-center flex-1 text-sm xl:text-base text-white">Claimed Bonus</span>
                      </div>

                      <div className="flex flex-col justify-stretch items-stretch max-h-60 overflow-y-scroll overflow-x-hidden">
                        {userReferrals?.referred_users
                          ?.filter((refUser) => refUser.is_active)
                          .map((user, i) => (
                            <div key={i} className="flex items-center justify-between bg-metaxseed-content-gray rounded-xl px-2 xl:px-4 py-2 mb-2 gothamBook">
                              <div className="flex flex-row justify-start items-center flex-1">
                                <span className="flex items-center text-sm xl:text-base mr-2">{user.uid.substring(0, 3) + "..." + user.uid.substring(user.uid.length - 3)} </span>

                                <button onClick={() => handleCopyToClipboard(user.uid)} className="cursor-pointer text-zinc-400 dark:text-zinc-600 hover:text-zinc-600 dark:hover:text-zinc-400">
                                  <Icon icon="solar:copy-linear" className="text-metaxseed-gray" />
                                </button>
                              </div>
                              <span className="flex items-center flex-1 text-sm xl:text-base">{user.all_time_mxs_gold_with_bonuses}</span>
                              <span className="flex flex-row justify-start items-center flex-1 text-sm xl:text-base">
                                {Math.floor(user.all_time_mxs_gold_with_bonuses / 10)}
                                <Image src="https://res.cloudinary.com/dot2onqdb/image/upload/v1729068489/gold_lr_h4yg2m.png" className="w-6 h-6 ml-2" alt="MXS GOLD" width={200} height={200} />
                              </span>
                            </div>
                          ))}
                      </div>

                      <div className="flex items-center justify-between bg-metaxseed-content-gray rounded-xl px-2 xl:px-4 py-2 gothamBook">
                        <span className="flex items-center flex-1 text-sm xl:text-base text-white"></span>
                        <span className="flex items-center flex-1 text-sm xl:text-base text-white"></span>
                        <span className="flex flex-row justify-start items-center flex-1 text-sm xl:text-base text-white">
                          Total:{" "}
                          {userReferrals?.referred_users
                            ?.filter((refUser) => refUser.is_active)
                            .map((user) => Math.floor(user.all_time_mxs_gold_with_bonuses / 10))
                            .reduce((a, b) => a + b, 0)}
                          <Image src="https://res.cloudinary.com/dot2onqdb/image/upload/v1729068489/gold_lr_h4yg2m.png" className="w-6 h-6 ml-2" alt="MXS GOLD" width={200} height={200} />
                        </span>
                      </div>
                    </Fragment>
                  )}
                </div>
              </Fragment>
            </div>
          </Modal>
        )}
      </Fragment>
    </Fragment>
  );
}
